export default {
  'app.pwa.offline': 'Anda kini di luar talian',
  'app.pwa.serviceworker.updated': 'Kandungan baharu tersedia',
  'app.pwa.serviceworker.updated.hint':
    'Sila tekan butang "Muat semula" untuk memuatkan semula halaman ini',
  'app.pwa.serviceworker.updated.ok': 'Muat semula',
};
